import {
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output,
  } from '@angular/core';
  import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
  import { Subject, takeUntil } from 'rxjs';
  import { NzMessageService } from 'ng-zorro-antd/message';
  import { FormControl, FormGroup, Validators } from '@angular/forms';
  import { BaseService } from 'src/app/services/base.service';
  import { FormValidationService } from 'src/app/services/form-validation.service';
  import { QRISLY_WEBHOOK, WEBHOOK } from 'src/app/constants/endpoint.const';

  @Component({
  standalone: false,
    selector: 'app-modal-add-webhook',
    templateUrl: './modal-add-webhook.component.html',
    styleUrls: ['./modal-add-webhook.component.scss'],
  })
  export class ModalAddWebhookComponent implements OnInit {
    destroy$ = new Subject();
    formGroupWebhookModal: FormGroup = new FormGroup({
      url: new FormControl('', [
        Validators.required,
        Validators.minLength(7),
      ]),
    });
    isValid: boolean = true;
    isValidPlatform: boolean = true;
    errIP: string = '';
    errPN: string = '';
    @Input() typeWebhook: string = '';
    @Output() updateWebhook = new EventEmitter();

    constructor(
      private activeModal: NgbActiveModal,
      private message: NzMessageService,
      private baseService: BaseService,
      private validationService: FormValidationService
    ) {}
    ngOnInit(): void {}

    close() {
      this.activeModal.close();
    }

    setRegexIP(event: KeyboardEvent) {
      return this.validationService.allowOnlyAlphaNumericSpecial(event);
    }

    setValueRulePlatform() {
      const value = this.formGroupWebhookModal.get('url')?.value || '';
      const result = this.validationService.validateUrl(value);
      this.isValidPlatform = result.valid;
      this.errPN = result.message;
    }

    submit() {
      const params = {
        webhook_url: this.formGroupWebhookModal.get('url')?.value,
      };
      this.baseService
        .putData(this.typeWebhook === 'qrisly' ? QRISLY_WEBHOOK : WEBHOOK, params)
        .pipe(takeUntil(this.destroy$))
        .subscribe(
          (res) => {
            this.message.create(
              'success',
              'Your webhook url has been successfully saved.'
            );
            this.activeModal.close();
            this.updateWebhook.emit();
          },
          (err) => {
            this.message.create('error', err.error.meta.message);
          }
        );
    }
  }
